import {
  Autocomplete,
  Button,
  Chip,
  DialogTitle,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import Grid from "@mui/material/Grid2";
import { Stack } from "@mui/system";
import { /*useContext,*/ useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  setSelectedTemplateType,
  setForecastStatus,
  setForecastNote,
  setAllFieldsFilled,
  setMonthlyData,
  setLastMonthActiveUsers,
} from "../../../../../features/forecastersSlice";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { setAllReviewed } from "../../../../../features/forecastersSlice";
// import SharedStateContext from "../../../../SharedStateProvider";
import { selectUserWebsitePermissions } from "../../../../../features/userSlice";

const CreateNewForeCasterBase = ({ onViewCreateTable, loading }: any) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [tempSelectedType, setTempSelectedType] = useState<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  // const { handleCreateClose } = useContext(SharedStateContext);
  const predictionFocusList = [
    { label: "FTD", value: 1 },
    { label: "Growth", value: 2 },
    { label: "Profit", value: 3 },
  ];
  const { lastMonthActiveUsers } = useSelector(
    (state: any) => state.forecasters,
  );

  const handleClose = () => {
    setOpen(false);
    setTempSelectedType(null);
  };

  // const handleCancelClick = () => {
  //   // First update the states
  //   dispatch(setSelectedTemplateType(null));
  //   dispatch(setAllReviewed(false));
  //   dispatch(setForecastStatus(null));
  //   dispatch(setForecastNote(""));
  //   dispatch(setAllFieldsFilled(false));
  //   dispatch(setLastMonthActiveUsers(null));

  //   // Then handle navigation with clean URL
  //   const params = new URLSearchParams(location.search);
  //   params.delete("predictionFocus");
  //   handleCreateClose();

  //   // Navigate once at the end
  //   const finalUrl = `/business_leader/forecaster?${params.toString()}`;
  //   navigate(finalUrl, { replace: true });
  // };

  const resetStates = () => {
    dispatch(setSelectedTemplateType(null));
    dispatch(setAllReviewed(false));
    dispatch(setForecastStatus(null));
    dispatch(setForecastNote(""));
    dispatch(setAllFieldsFilled(false));
    dispatch(setLastMonthActiveUsers(null));
  };

  useEffect(() => {
    // Listen for navigation/unmount
    const unblock = () => {
      const params = new URLSearchParams(location.search);
      if (params.has("predictionFocus")) {
        params.delete("predictionFocus");
        navigate(`${location.pathname}?${params.toString()}`, {
          replace: true,
        });
      }
      resetStates();
    };

    window.addEventListener("beforeunload", unblock);

    return () => {
      window.removeEventListener("beforeunload", unblock);
      resetStates();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const newSearchParams = new URLSearchParams(location.search);
    if (
      location.pathname === "/business_leader/forecaster/Createnewforecast" &&
      newSearchParams.get("page") !== "0"
    ) {
      newSearchParams.set("page", "0");
      navigate(`${location.pathname}?${newSearchParams.toString()}`, {
        replace: true,
      });
    }
  }, [location.search, location.pathname, navigate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const predictionFocus = params.get("predictionFocus");
    if (predictionFocus && !selectedTemplateType) {
      const focusValue = parseInt(predictionFocus);
      if ([1, 2, 3].includes(focusValue)) {
        dispatch(setSelectedTemplateType(focusValue));
        onViewCreateTable();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const predictionFocus = params.get("predictionFocus");

    if (predictionFocus) {
      const focusValue = parseInt(predictionFocus);
      if ([1, 2, 3].includes(focusValue)) {
        dispatch(setSelectedTemplateType(focusValue));
      } else {
        params.delete("predictionFocus");
        navigate(`${location.pathname}?${params.toString()}`, {
          replace: true,
        });
        dispatch(setSelectedTemplateType(null));
      }
    } else {
      dispatch(setSelectedTemplateType(null));
    }
  }, [location.search, dispatch, location.pathname, navigate]);

  const handlePredictionFocusChange = (newValue: any) => {
    if (newValue) {
      if (selectedTemplateType) {
        setTempSelectedType(newValue);
        setOpen(true);
      } else {
        const updatedParams = new URLSearchParams(location.search);
        updatedParams.set("predictionFocus", newValue.value.toString());
        navigate(`${location.pathname}?${updatedParams.toString()}`);
        dispatch(setSelectedTemplateType(newValue.value));
        onViewCreateTable();
        dispatch(setMonthlyData([]));
      }
    } else {
      dispatch(setSelectedTemplateType(null));
      const updatedParams = new URLSearchParams(location.search);
      updatedParams.delete("predictionFocus");
      navigate(`${location.pathname}?${updatedParams.toString()}`, {
        replace: true,
      });
      dispatch(setAllReviewed(false));
      dispatch(setMonthlyData([]));
    }
  };

  const handleConfirmChange = () => {
    if (tempSelectedType) {
      const updatedParams = new URLSearchParams(location.search);
      updatedParams.set("predictionFocus", tempSelectedType.value.toString());
      navigate(`${location.pathname}?${updatedParams.toString()}`);
      dispatch(setSelectedTemplateType(tempSelectedType.value));
      onViewCreateTable();
    }
    handleClose();
  };

  const [searchParams] = useSearchParams();
  const selectedYear = searchParams.get("selectedYear") as any;
  const selectedTemplateType = searchParams.get("predictionFocus") as any;
  const websitePermissions = useSelector(selectUserWebsitePermissions) as any;
  const selectedSite = searchParams.get("selectedSite") as any;
  const forecastNote = useSelector(
    (state: any) => state?.forecasters?.forcastNote,
  );

  const siteName = websitePermissions.find(
    (site: any) => Object.keys(site)[0] === selectedSite,
  )?.[selectedSite]?.ui_site_name;

  return (
    <>
      <Paper sx={{ padding: "16px 16px 8px 16px", boxShadow: 0 }} elevation={0}>
        <Grid
          container
          spacing={2}
          alignItems={"center"}
          mb={2}
          justifyContent={"space-between"}
        >
          <Stack direction="row" alignItems="center" gap={2} flexWrap="wrap">
            <Stack flexDirection={"row"} alignItems={"center"} gap={2}>
              <Typography variant="h5">
                {selectedYear} {"Vr."}{" "}
                {selectedTemplateType === "1"
                  ? "1"
                  : selectedTemplateType === "2"
                    ? "2"
                    : selectedTemplateType === "3"
                      ? "3"
                      : ""}
              </Typography>{" "}
              {/* need to check later */}
            </Stack>
            <Stack
              flexDirection={"row"}
              alignItems={"center"}
              gap={2}
              sx={{ width: "120px" }}
            >
              <Autocomplete
                fullWidth
                key={`prediction-focus-${selectedTemplateType || "empty"}`}
                size="small"
                options={predictionFocusList}
                getOptionLabel={(option) => option.label}
                onChange={(_, newValue) =>
                  handlePredictionFocusChange(newValue)
                }
                value={
                  selectedTemplateType
                    ? predictionFocusList.find(
                        (option) =>
                          option.value === Number(selectedTemplateType),
                      )
                    : null
                }
                clearOnBlur={false}
                clearOnEscape
                disableClearable={false}
                renderInput={(params) => (
                  <TextField
                    color="secondary"
                    {...params}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                    variant="standard"
                    sx={{
                      "& .MuiInput-underline:before": {
                        borderBottom: "2px solid rgba(0,0,0,0.6)",
                      },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottom: "2px solid rgba(0,0,0,0.8)",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottom: "2px solid #7B1FA2",
                      },
                      "& .MuiInput-underline.Mui-disabled:before": {
                      borderBottom: "1px solid #0000006B !important",
                    },
                    }}
                  />
                )}
              />
            </Stack>
            <Stack flexDirection={"row"} gap={0.5}>
              <Typography fontWeight={400}>
                {siteName && (
                  <Chip
                    label={siteName}
                    size="small"
                    sx={{
                      fontWeight: 400,
                      fontSize: 13,
                      height: 28,
                      backgroundColor: "#7B1FA2",
                      color: "#ffffff",
                    }}
                  />
                )}
              </Typography>
            </Stack>
          </Stack>

          <Stack direction="row" spacing={2}>
            {/* <Button color="secondary" disabled={loading} variant="text">
                <Stack onClick={handleCancelClick}>Cancel</Stack>
              </Button> */}
            <Button
              variant="text"
              color="secondary"
              data-tracker="130"
              onClick={() => dispatch(setForecastStatus("draft"))}
              disabled={!selectedTemplateType || loading}
            >
              Save as draft
            </Button>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<SaveIcon />}
              data-tracker="130"
              onClick={() => dispatch(setForecastStatus("publish"))}
              disabled={!selectedTemplateType || loading}
            >
              Save & Publish
            </Button>
          </Stack>
        </Grid>
        <Grid
          container
          alignItems="center"
          spacing={2}
          sx={{ whiteSpace: "nowrap" }}
          mt={1}
          justifyContent={"space-between"}
        >
          <Grid size={12} alignItems={"center"} flexDirection={"row"}>
            <Grid container spacing={4}>
              {/* Note */}
              <Grid size={4}>
                <TextField
                  fullWidth
                  color="secondary"
                  placeholder="Choose industry from the list."
                  label="Note"
                  value={forecastNote}
                  onChange={(e) => dispatch(setForecastNote(e.target.value))}
                  variant="standard"
                  size="small"
                  disabled={!selectedTemplateType || loading}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                  sx={{
                    "& .MuiInput-underline.Mui-disabled:before": {
                      borderBottom: "1px solid #0000006B !important",
                    },
                  }}
                />
              </Grid>

              <Grid size={2}>
                <TextField
                  fullWidth
                  color="secondary"
                  label="Last Month Active Users"
                  value={lastMonthActiveUsers ?? ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Allow empty
                    if (value === "") {
                      dispatch(setLastMonthActiveUsers(""));
                      return;
                    }

                    // Allow numbers with up to 2 decimal places
                    const regex = /^\d+(\.\d{0,2})?$/;

                    if (regex.test(value)) {
                      dispatch(setLastMonthActiveUsers(value));
                    }
                  }}
                  variant="standard"
                  size="small"
                  type="text"
                  disabled={!selectedTemplateType || loading}
                  slotProps={{
                    inputLabel: { shrink: true },
                    input: {
                      inputProps: {
                        inputMode: "decimal", // mobile numeric keypad
                      },
                    },
                  }}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottom: "2px solid rgba(0,0,0,0.6)",
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: "2px solid rgba(0,0,0,0.8)",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottom: "2px solid #7B1FA2",
                    },

                    "& .MuiInput-underline.Mui-disabled:before": {
                      borderBottom: "1px solid #0000006B !important",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      {/* Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ color: "#000000DE" }}>
          {"Are you sure you want to change the prediction focus?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText fontWeight={500} sx={{ color: "#000000DE" }}>
            Changing the prediction focus will alter the required the input
            fields and discard all data you have previously reviewed and edited.
            Are you sure you want to change the prediction focus?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px 20px 24px" }}>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            cancel
          </Button>
          <Button
            onClick={handleConfirmChange}
            color="secondary"
            variant="contained"
            autoFocus
          >
            change focus
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateNewForeCasterBase;
